import { createSlice } from '@reduxjs/toolkit';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    selectedOwner: 'all',
    selectedCreator: 'all',
  },
  reducers: {
    setSelectedOwner(state, action) {
      state.selectedOwner = action.payload;
    },
    setSelectedCreator(state, action) {
      state.selectedCreator = action.payload;
    },
  },
});

export const { setSelectedOwner, setSelectedCreator } = filtersSlice.actions;
export default filtersSlice.reducer;
